module.exports = __webpack_public_path__ + "img/scene4-5.e5da2304.png";